import { useOrganizationUsageQuery } from "./useOrganizationUsageQuery";

import { ENDPOINTS } from "@/api/application-api";
import {
  GetOrganizationDeploymentUsageChartDataParams,
  OrganizationDeploymentUsageChartData,
} from "@/types/organization-usage";

export const useOrganizationDeploymentUsageData = (
  params: GetOrganizationDeploymentUsageChartDataParams,
) =>
  useOrganizationUsageQuery<OrganizationDeploymentUsageChartData>({
    ...params,
    queryKey: "organization_deployments_usage",
    endpoint: ENDPOINTS.organization_deployments_usage,
  });
